import { lazy, Suspense } from 'react';
import SharedHelmet from '../Fr/Helmet';

const CardGroups = lazy(() => import("./CardGroups"));
const Intro = lazy(() => import("./Intro"));

const TITLE = 'Calculatrices en ligne gratuites en francais | Do Calculate';
const DESCRIPTION = "Comparez, calculez et convertissez en quelques secondes avec nos calculatrices en francais: maths, sante, finance, etudes, physique, chimie, nutrition et bien plus. Resultats rapides, interface claire et outils mis a jour en continu.";
const KEYWORDS = "calculatrice en ligne, calculatrices gratuites, calculatrice en francais, calculatrice math, calculatrice sante, calculatrice finance, convertisseur, outils de calcul";
const OG_URL = 'https://do-calculate.com/fr/';
const IMAGE_URL = 'https://do-calculate.com/logo512.png';

function LandingPage() {
    return (
        <div>
            <SharedHelmet 
                TITLE={TITLE} 
                DESCRIPTION={DESCRIPTION} 
                KEYWORDS={KEYWORDS} 
                OG_URL={OG_URL} 
                IMAGE={IMAGE_URL}
            />
            <Suspense fallback={<div>Chargement...</div>}>
                <Intro />
                <CardGroups />
            </Suspense>
        </div>
    );
}

export default LandingPage;
